import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import { DESKTOP_MIN_WIDTH, FEMALE, MALE } from 'constants';
import {
  FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_PERSONAL_DETAILS_GENDER_FIELD,
} from 'constants/fx';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputGenderRadio = ({
  information,
  setInformation,
  validation,
  setValidation,
  isDisabled,
}) => {
  const { t } = useLang();

  const isMale =
    information[FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME] === MALE;
  const isFemale =
    information[FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME] === FEMALE;

  const validRef = useRef(null);

  useEffect(() => {
    if (validation[FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME]) {
      validRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [validation]);

  const handleOnChange = (value) => {
    const newInformation = {
      ...information,
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME]: value,
    };
    setInformation(newInformation);

    const newValidation = {
      ...validation,
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME]: '',
    };
    setValidation(newValidation);
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 =
      FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME + '1';

    return (
      <FormCheckboxRadio
        name={FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME}
        className={`${formCheckRadioClassName1} ${isMale ? 'active' : ''}`}
        label={t('form_gender_male')}
        isChecked={isMale}
        onClick={() => (!isDisabled ? handleOnChange(MALE) : {})}
      />
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 =
      FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME + '2';

    return (
      <FormCheckboxRadio
        name={FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME}
        className={`${formCheckRadioClassName2} ${isFemale ? 'active' : ''}`}
        label={t('form_gender_female')}
        isChecked={isFemale}
        onClick={() => (!isDisabled ? handleOnChange(FEMALE) : {})}
        styles={{ marginRight: '0px' }}
      />
    );
  };

  return (
    <FormGroupStyled>
      <FormLabel onClick={(e) => e.preventDefault()}>
        {t(
          FX_ADD_TRANSACTION_ENTER_INFORMATION_PERSONAL_DETAILS_GENDER_FIELD.label
        )}
        <span>*</span>
      </FormLabel>
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
      {validation[FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME] && (
        <FormControlFeedback ref={validRef} hidden={false} type="invalid">
          {t(validation[FX_ADD_TRANSACTION_ENTER_INFORMATION_GENDER_NAME])}
        </FormControlFeedback>
      )}
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  display: table;
  width: 100%;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
    clear: both;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  display: block;
  color: var(--ds-c-grey-dark);
  margin-bottom: 16px;

  span {
    color: var(--c-required);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

const FormControlFeedback = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  color: var(--ds-c-red);
  position: absolute;
  margin-top: 4px;
  margin-bottom: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

export default FormInputGenderRadio;
